module.exports = __webpack_public_path__ + "img/logo.a7f963e1.png";